import React from 'react';
import './Services.css';

const services = [
  {
    img: 'https://embracebeautyclinic.com/assets/prp-img.png',
    icon: 'https://embracebeautyclinic.com/assets/icon/prp.png',
    title: 'PRP Hair Restoration',
    desc: 'Uses your own platelets to stimulate hair growth, improve thickness, and reduce hair loss. Safe and effective.',
  },
  {
    img: 'https://embracebeautyclinic.com/assets/SkinRejuvenation.png',
    icon: 'https://embracebeautyclinic.com/assets/icon/Skin-Rejuvenation.png',
    title: 'PRP Skin Rejuvenation',
    desc: 'Boosts collagen, improves skin texture, and reduces fine lines using your body\'s natural healing properties.',
  },
  {
    img: 'https://embracebeautyclinic.com/assets/Micro-needling.png',
    icon: 'https://embracebeautyclinic.com/assets/icon/Micro-needling-icon.png',
    title: 'Micro-needling',
    desc: 'Creates micro-injuries to stimulate collagen, reducing scars, wrinkles, and uneven skin texture. Can be combined with PRP.',
  },
  {
    img: 'https://embracebeautyclinic.com/assets/BotoxInjectables.png',
    icon: 'https://embracebeautyclinic.com/assets/icon/BotoxInjectables-icon.png',
    title: 'Botox Injectables',
    desc: 'Smooth wrinkles and prevent new ones.',
  },
  {
    img: 'https://embracebeautyclinic.com/assets/DermalFillers.png',
    icon: 'https://embracebeautyclinic.com/assets/icon/Dermal Fillers-icon.png',
    title: 'Dermal Fillers',
    desc: 'Restores volume, smooths wrinkles, and enhances facial contours with hyaluronic acid-based injections.',
  },
  {
    img: 'https://embracebeautyclinic.com/assets/PostHairTransplantTreatments.png',
    icon: 'https://embracebeautyclinic.com/assets/icon/prp.png',
    title: 'Post Hair Transplant Treatments',
    desc: 'Supports healing, strengthens follicles, and improves hair growth with PRP and specialized scalp treatments.',
  },
];

const Services = ({ openModal }) => {
  return (
    <section className="services" id="our-services">
      <div className="container">
        <div className="services-header">
          <span className="section-tag">Our Services</span>
          <h2 className="section-title">What Service We Offer</h2>
          <p className="services-sub">
            At Embrace Beauty, we understand that everyone's aesthetic goals are unique.
          </p>
        </div>

        <div className="services-grid">
          {services.map((s, i) => (
            <div className="service-card" key={i}>
              <div className="service-card-img">
                <img src={s.img} alt={s.title} />
                <div className="service-card-icon">
                  <img src={s.icon} alt={s.title + ' icon'} onError={e => e.target.style.display='none'} />
                </div>
              </div>
              <div className="service-card-body">
                <h3>{s.title}</h3>
                <p>{s.desc}</p>
                <button className="service-btn" onClick={openModal}>Book Appointment</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
